import { Alert } from '@mui/material'
import IframeResizer from 'iframe-resizer-react'
import { FC, useContext, useEffect, useState } from 'react'

import { Page } from '../../components'
import { OutlinedBox } from '../../components/SharedUI'
import useAccessTokenAndShopId from '../../hooks/useAccessTokenAndShopId/useAccessTokenAndShopId'
import { AppContext } from '../../providers/AppProvider/AppProvider'
import { useInitiateAccountLoginMutation } from '../../redux/api/independentApi'

export const ExpenseCardPage: FC = () => {
  const { canAccessExpenseCard } = useContext(AppContext)
  const { accessToken, shopId } = useAccessTokenAndShopId()
  const [generateLink] = useInitiateAccountLoginMutation()

  const [url, setUrl] = useState<string>('')

  useEffect(() => {
    const generateExpenseCardLink = async () => {
      const link = await generateLink({
        authorization: accessToken,
        shop: shopId
      }).unwrap()

      setUrl(link)
    }

    if (canAccessExpenseCard && !url) {
      generateExpenseCardLink()
    }
  }, [accessToken, generateLink, shopId, url, setUrl, canAccessExpenseCard])

  const [messageData, setMessageData] = useState<string | undefined>(undefined)

  const onResized = (data: {
    iframe: IframeResizer.IFrameComponent
    height: number
    width: number
    type: string
  }) => {
    setMessageData(data.type)
  }

  const [countdown, setCountdown] = useState(10)

  useEffect(() => {
    const interval = setInterval(() => {
      setCountdown((prevCountdown) =>
        prevCountdown > 0 ? prevCountdown - 1 : 0
      )
    }, 1000)

    return () => clearInterval(interval)
  }, [countdown])

  return (
    <Page title="Corporate Card">
      <OutlinedBox title="Corporate Card" noPadding={true}>
        <IframeResizer
          src={url}
          allow="clipboard-write"
          checkOrigin={false}
          style={{ width: '1px', height: '0px', minWidth: '100%', border: 0 }}
          onResized={onResized}
        />
      </OutlinedBox>
      {!canAccessExpenseCard && (
        <Alert severity="error" variant="filled">
          You don&apos;t have permissions to access this page. Contact your
          admin for more details.
        </Alert>
      )}
      {canAccessExpenseCard && !messageData && (
        <Alert severity="info" variant="filled">
          You are being forwarded to the requested page. If the page does not
          load after {countdown} seconds, refresh the page
        </Alert>
      )}
    </Page>
  )
}

export default ExpenseCardPage
